import { Col, Row } from "antd";
import Submit from './Submit';
import Details from './Details';

export default function Details_Submit(props) {

   return (
      <>
         <Row>
            <Col span={12} style={{ padding: "10px", background: "#FFF" }}>
               <Details
                  homeworkID={props.homeworkID}
               />
            </Col>
            <Col span={12} style={{ padding: "10px", background: "#FFF" }}>
               <Submit
                  homeworkID={props.homeworkID}
                  onCancelCallback={props.onCancelCallback}
                  onSubmitCallback={props.onSubmitCallback}
                  canSubmit={props.canSubmit}
                  returned={props.returned}
                  remarks={props.remarks}
               />
            </Col>
         </Row>
      </>
   );
}